import { render, staticRenderFns } from "./chooseDept.vue?vue&type=template&id=aa9b957c"
import script from "./chooseDept.vue?vue&type=script&lang=js"
export * from "./chooseDept.vue?vue&type=script&lang=js"
import style0 from "./chooseDept.vue?vue&type=style&index=0&id=aa9b957c&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports